<h2 mat-dialog-title>{{ data.licence.user ? 'Reassign surveyor seat' : 'Assign surveyor seat' }}</h2>

<div mat-dialog-content>
    @if (data.users.length) {
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Assign to</mat-label>
            <mat-select [(value)]="userId">
                @for (user of data.users; track user.id) {
                    <mat-option [value]="user.id">{{ user.name }} · {{ user.email }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if (data.licence.user) {
            <p>{{ data.licence.user.name }} will lose App access when this seat is reassigned.</p>
        }
    } @else {
        <p>There are no active users without a surveyor seat.</p>
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="null">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="userId" [disabled]="userId === null">{{ data.licence.user ? 'Reassign' : 'Assign' }}</button>
</div>
